module.exports = __webpack_public_path__ + "img/kangfuhuli_image_zy.64b9a1bf.png";